// extracted by css-extract-rspack-plugin
export default {"sectionIcon":"sectionIcon-Wjj60C","positionList":"positionList-_jnEvT","section":"section-wXhCbt"};